import { ClipboardArrowDownIcon } from './ClipboardArrowDownIcon';

/**
 * author: Google
 * id 863E0318-495E-437A-B22B-3C1274D108E6
 * name clipboard-arrow-down
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-arrow-down.svg
 * tags
 */
export const AssignmentReturnedIcon = ClipboardArrowDownIcon;
export default AssignmentReturnedIcon